import { Dropdown, IDropdownOption } from '@fluentui/react';
import React, {useEffect} from 'react';

interface IMarkupTypeSelectionProps {
    value?: string;
    onChange?: (markupType: string) => void;
    label?: string;
    disabled?: boolean;
    overrideValue?: string;
    storefrontId?: string;
    isLowestLevel?: boolean;
    bundleContext?: boolean;
}

export const MARKUP_TYPES = {
    '' : 'Inherit',
    'FIXED': 'Fixed',
    'PERCENT': 'Percentage',
    'GROSS_MARGIN': 'Gross Margin',
}

export const MARKUP_TYPES_BUNDLES = {
    '' : 'Inherit',
    'PERCENT': 'Percentage',
    'GROSS_MARGIN': 'Gross Margin',
}

const MarkupTypeSelection: React.FC<IMarkupTypeSelectionProps> = (props) => {
    
    const [effectiveMarkupType, setEffectiveMarkupType] = React.useState<string>('');

    useEffect(() => {
        if(props.value === 'MARKUP_FIXED'){
            setEffectiveMarkupType('FIXED');
        }
        else{
            setEffectiveMarkupType(props.value ?? '');
        }
    }, [props.value]);
    
    const getValue =() => {
        if(effectiveMarkupType){
            return effectiveMarkupType;
        }
        return  ''
    }

    const options: IDropdownOption[] = props.bundleContext ?
        (Object.entries(MARKUP_TYPES_BUNDLES).map(([key, value]) => {
            return {key, text: value}})) :
        (Object.entries(MARKUP_TYPES).map(([key, value]) => {
            return {key, text: value}
        })
    );
    return (
        <Dropdown
            label={props.label}
            selectedKey={getValue()}
            disabled={props.disabled}
            onChange={(e, option) => {
                if (option && props.onChange) {
                    props.onChange(option.key as string);
                }
            }}
            options={options}
        />
    );
}

export default MarkupTypeSelection;